module.exports = __webpack_public_path__ + "static-portal/img/map-csqp2.d3864e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-csqp2.jpg
// module id = 626u
// module chunks = 4